import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';
import { AppState } from './app.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable()
export class AzureLoggerService {
    private appInsights: ApplicationInsights;

    public constructor(
        private appState: AppState,
        private router: Router, 
        private activatedRoute: ActivatedRoute
    ) {
        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: environment.appInsights.instrumentationKey,
                enableAutoRouteTracking: false,
                addRequestContext: () => this.getCustomProperies(),
            },
        });
        this.appInsights.loadAppInsights();
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((navEndEvent: any) => {
                const pageTitle = this.activatedRoute?.snapshot?.data['title'];
                this.logPageView(pageTitle, navEndEvent?.url);
            });
    }

    public logPageView(name?: string, url?: string) {
        this.appInsights.trackPageView({
            name,
            uri: url,
            properties: this.getCustomProperies()
        });
    }

    public logEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights.trackEvent({ name }, properties);
    }

    public logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        this.appInsights.trackMetric({ name, average }, properties);
    }

    public logException(exception: Error, severityLevel?: number) {
        this.appInsights.trackException(
            { exception, severityLevel },
            this.getCustomProperies()
        );
    }

    public logTrace(message: string, properties?: { [key: string]: any }) {
        const allProperties = Object.assign({}, this.getCustomProperies(), properties);
        this.appInsights.trackTrace({ message }, allProperties);
    }

    private getCustomProperies() {debugger
        var user = this.appState.user.getValue();
        return {
            userId: user?.userSubId,
            shardName: user?.shardName,
            userEmail: user?.email,
            afpName: user?.verificationInfo?.insuredName ?? 'None'
        };
    }
}
